export const settings = {
  languages: [
    { label: "English", value: 'en' },
  ],
  categoriesMapping: {
    0: {name: "explore", displayName: "Things To Do"},
    2003: {name: "explore", displayName: "Things To Do"},
    3000: {name: "explore", displayName: "Business Directory"},
    3001: {name: "dine", displayName: "Dining"},
    3002: {name: "shop", displayName: "Shopping"},
    3003: {name: "stay", displayName: "Places to Stay"},
    3004: {name: "explore", displayName: "Things To Do"},
    3005: {name: "explore", displayName: "Nonprofit"},
  },
  labelCategories: 'Categories',
  displaySocial: false,
  connectWithUsLogoWider: false,
  differentPlaceholders: true,
  site: {
    name: 'CONVENTION & VISITOR BUREAU',
    address: `105 N. First Street Coeur d'Alene, ID 83814`,
    phone: '(208) 664-3194',
    map: 'https://maps.app.goo.gl/FsuEJBt74d9TLVyF6',
    latitude: 47.673887,
    longitude: -116.8682447,
    website:'https://coeurdalene.org/',
    privacyLink:'https://coeurdalene.org/privacy-policy/',
    twitter:'https://twitter.com/PoconoTourism',
    facebook: 'https://www.facebook.com/PoconoTourism',
    pinterest:'https://www.pinterest.com/poconotourism/',
    instagram:'https://instagram.com/poconotourism/',
    youtube:'',
    splashImage: '../themes/CDA/assets/splashscreens/bg_img.png',
    homeHeaderImage: '../themes/CDA/assets/login/group-row.png',
    homeEvents: false,
    featuredEvents: true,
  },
  debug: true,
  organizations: [
    {
      logo: `../../../themes/CDA/assets/connect-with-us/logo.png`,
      website: `https://cdadowntown.com/`,
      phone: `208-667-5986`,
      location: `https://maps.app.goo.gl/MCrJDuJBfMGH5Suq5`,
      latitude: 47.6739165,
      longitude: -116.7858442,
      address: `105 N 1st St, Coeur d'Alene, ID 83814, USA`
    },
    {
      logo: `../../../themes/CDA/assets/connect-with-us/logo2.png`,
      website: `https://coeurdalene.org/`,
      phone: `(208) 664-3194`,
      location: `https://maps.app.goo.gl/rJPXmvMQmR4caV3t9`,
      latitude: 47.6739165,
      longitude: -116.7858442,
      address: `105 N 1st St, Coeur d'Alene, ID 83814, USA`
    },
    {
      logo: `../../../themes/CDA/assets/connect-with-us/logo3.png`,
      website: `https://cdachamber.com/`,
      phone: `+1 208-664-3194`,
      location: `https://maps.app.goo.gl/AwV69WWhzLSRUeSk8`,
      latitude: 47.6739165,
      longitude: -116.7858442,
      address: `105 N 1st St, Coeur d'Alene, ID 83814, USA`
    }
  ],
  eventsCategorysAllowed: [
    4, 30, 16, 7, 8, 9, 50
  ],
  regionsData: [],
  hasRegions: false,
  hasSocialWall: true,
  defaultRegion: null,
  hasEventsData: true,
  hasEventsDates: false,
  filterEventsByCategories: false,
  filterEventsByfeature: false,
  filterListingsByfeature: false,
  homeOptions: {
    enabled: false,
    optionPageId: 9276,
    fullWithFirstItemMenu: false
  },
  showGradient: true,
  themeColors:{
    headerColor: 'primary',
    tabsColor: 'primary',
    focusedTabColor: 'secondary'
  }
};
